import { useState } from "react";
import { useDispatch } from "react-redux";

import { bulkRemoveAdminEventRequestsRequest } from "../../../../../../store/AdminEventRequests/actions";

const useAdminEditRemovalReason = ({
  rows,
  selectedIds,
  listParams,
  setSelectedIds,
  onRefreshEvent,
}) => {
  const dispatch = useDispatch();
  const [editReasonTargetIds, setEditReasonTargetIds] = useState([]);
  const editReasonApplicants = rows.filter((row) =>
    editReasonTargetIds.includes(row.id),
  );

  const openEditReasonModal = () => {
    setEditReasonTargetIds(selectedIds);
  };

  const closeEditReasonModal = () => {
    setEditReasonTargetIds([]);
  };

  const confirmEditReason = ({ reason }) => {
    dispatch(
      bulkRemoveAdminEventRequestsRequest({
        eventRequestIds: editReasonTargetIds,
        removalReason: reason,
        listParams,
        onSuccess: () => {
          setSelectedIds([]);
          setEditReasonTargetIds([]);
          onRefreshEvent?.({ silent: true });
        },
      }),
    );
  };

  return {
    editReasonApplicants,
    isEditReasonModalOpen: editReasonTargetIds.length > 0,
    openEditReasonModal,
    closeEditReasonModal,
    confirmEditReason,
  };
};

export default useAdminEditRemovalReason;
